import { type FC } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface ModalCharacterBackgroundProps {
  characterImage?: {
    png: string;
    webp: string;
  };
  backgroundImage: {
    png: string;
    webp: string;
  };
  classNames?: {
    wrapper?: string;
    character?: string;
    image?: string;
  };
}

const ModalCharacterBackground: FC<ModalCharacterBackgroundProps> = ({
  backgroundImage,
  characterImage,
  classNames,
}) => {
  return (
    <div
      className={cn(css.modalBackground, 'rounded-2xl', classNames?.wrapper)}
    >
      <picture className={cn('rounded-2xl', classNames?.image)}>
        <source
          className="rounded-2xl"
          srcSet={backgroundImage.webp}
          type="image/webp"
        />
        <img
          className="w-full h-full object-cover rounded-2xl"
          src={backgroundImage.png}
          alt="onboarding"
        />
      </picture>
      {characterImage && (
        <div
          className={cn(
            'absolute h-[116%] bottom-0 left-1/2 -translate-x-[calc(50%+15px)]',
            classNames?.character,
          )}
        >
          <picture className="h-full">
            <source
              className="h-full"
              srcSet={characterImage.webp}
              type="image/webp"
            />
            <img
              className="h-full object-cover"
              src={characterImage.png}
              alt="onboarding"
            />
          </picture>
        </div>
      )}
    </div>
  );
};

export { ModalCharacterBackground };
